import React from "react";

import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const RequireGuest = () => {
  const { user } = useSelector((state) => state.Auth);

  if (!user.token) {
    return <Outlet />;
  } else {
    return <Navigate to="/" replace />;
  }
};

export default RequireGuest;
